import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export const ptBrMessages = {
  campanha: 'Campanha',
  campanhas: 'Campanhas',
  degustacao: 'Degustação',
  minhaDegustacao: 'Minha degustação',
  degustacoesAtivas: 'Degustações ativas',
  consultasRestantes: 'restantes',
  degustacaoTitulo: 'Você tem uma degustação de consulta!',
  degustacaoDescricao: 'Aproveite sua degustação com',
  consultasGratis: 'consulta(s) grátis',
  seuVoucher: 'Seu voucher',
  coleVoucher: 'Cole o voucher para aplicar',
  coleVoucherPlaceholder: 'Cole aqui o código do voucher',
  aplicarVoucher: 'Aplicar voucher',
  copiar: 'Copiar',
  copiado: 'Copiado',
  verPromocao: 'Ver promoção',
  atencao: 'Atenção',
  examplePhrase: 'frase de descrição da seção. breve e focada nas ações.',
  user: 'Usuário',
  logout: 'Sair',
  home: 'Início',
  consultaCredito: 'Consulta de Crédito',
  opcaoConsulta: 'Opção Consulta',
  consultaPF: 'Consultar Pessoa Física',
  consultaPJ: 'Consultar Pessoa Jurídica',
  fone: 'Telefone',
  celular: 'Celular',
  data: 'Data',
  dadosConsulta: 'Dados da Consulta',
  nome: 'Nome',
  nomeMae: 'Nome da Mãe',
  documento: 'Documento',
  situacao: 'Situação',
  dataNascimento: 'Nascimento',
  endereco: 'Endereço',
  sexo: 'Sexo',
  email: 'E-mail',
  logradouro: 'Logradouro',
  cidade: 'Cidade',
  uf: 'UF',
  complemento: 'Complemento',
  bairro: 'Bairro',
  numero: 'Número',
  historicoEndereco: 'Histórico Endereço',
  historico: 'Histórico',
  login: 'Login',
  senha: 'Senha',
  ultimos30Dias: 'Últimos 30 Dias:',
  de31a60Dias: 'De 31 a 60 Dias:',
  de61a90Dias: 'De 61 a 90 Dias:',
  acima90Dias: 'Acima de 90 Dias:',
  quantidade: 'Quantidade',
  segmento: 'Segmento',
  listaConsulta: 'Consultas',
  participacaoEmpresa: 'Participações em empresas',
  cnpj: 'CNPJ',
  razaoSocial: 'Razão Social',
  tipo: 'Tipo',
  participacao: 'Participação',
  dataEntrada: 'Data Entrada',
  dataAtualizacao: 'Data Atualização',
  status: 'Status',
  riscoCredito: 'Risco de crédito:',
  probabilidadePagamento: 'Probabilidade de pagamento:',
  score: 'Score',
  usuario: 'Usuário',
  usuarios: 'Usuários',
  cadastrar: 'Cadastrar',
  inativo: 'Inativo',
  ativo: 'Ativo',
  ativar: 'Ativar',
  inativar: 'Inativar',
  todos: 'Todos',
  confirmarInativarPlano: 'Deseja realmente inativar o plano',
  cache: 'Cache',
  historicoConsulta: 'Histórico de Consultas',
  autor: 'Autor',
  comarca: 'Comarca',
  origem: 'Origem',
  dataDistribuicao: 'Dt. Distribuição',
  dataProcesso: 'Dt. Processo',
  vara: 'Vara',
  forum: 'Fórum',
  cidadeUF: 'Cidade/UF',
  acoes: 'Ações',
  ccfs: 'Cheques sem Fundos',
  codigoBanco: 'Código Banco',
  banco: 'Banco',
  agencia: 'Agência',
  motivo: 'Motivo',
  dataUltimaOcorrencia: 'Dt. Última Ocorrência',
  dataRegistro: 'Dt. Registro',
  dataVencimento: 'Dt. Vencimento',
  natureza: 'Natureza',
  credor: 'Credor',
  cnpjCredor: 'CNPJ Credor',
  contrato: 'Contrato',
  valor: 'Valor',
  apontamentos: 'Apontamentos',
  dataUltimoLogin: 'Dt. Último Login',
  ipUltimoLogin: 'Ip Último Login',
  cadastralCOPQ: 'Cadastral COPQ',
  reu: 'Réu',
  acoesCompleta: 'Ações Completa',
  rendaPresumida: 'Renda Presumida',
  enderecos: 'Endereços',
  telefones: 'Telefones',
  faixa: 'Faixa',
  nomePai: 'Nome do Pai',
  escolaridade: 'Escolaridade',
  emails: 'E-mails',
  completaPF: 'Completa Pessoa Física',
  empresas: 'Empresas',
  avalista: 'Avalista',
  modalidade: 'Modalidade',
  negativacoes: 'Negativações',
  pendencias: 'Pendências',
  cartorio: 'Cartório',
  protestos: 'Protestos',
  renda: 'Renda',
  capitalSocial: 'Capital Social',
  naturezaJuridica: 'Natureza Jurídica',
  dataAbertura: 'Data Abertura',
  cnae: 'CNAE',
  segmentoCnae: 'Segmento CNAE',
  enviarParaQuod: 'Enviar para Quod',
  nomeFantasia: 'Nome Fantasia',
  cnaes: 'CNAEs',
  codigo: 'Código',
  descricao: 'Descrição',
  completaPJ: 'Completa Pessoa Jurídica',
  cargo: 'Cargo',
  socios: 'Sócios',
  alterarSenha: 'Alterar Senha',
  novaSenha: 'Nova Senha',
  repetirNovaSenha: 'Repetir Nova Senha',
  processo: 'Processo',
  assunto: 'Assunto',
  dataInicial: 'Data Inicial',
  dataFinal: 'Data Final',
  relatorioConsultaSintetica: 'Relatório Consulta Sintética',
  tamanho: 'Tamanho',
  downloads: 'Downloads',
  tipoArquivo: 'Extensão',
  arquivo: 'Arquivo',
  filtroConsulta: 'Filtro Consulta',
  protocolo: 'Protocolo',
  opcoesConsulta: 'Opções Consulta',
  clientes: 'Clientes',
  cliente: 'Cliente',
  responsavel: 'Responsável',
  whatsapp: 'WhatsApp',
  observacoes: 'Observações',
  inserirEmail: 'Insira seu E-mail',
  inserirSenha: 'Insira sua nova senha',
  repetirSenha: 'Repita sua nova senha',
  avisos: 'Avisos',
  faixaFaturamento: 'Faixa Faturamento',
  subFaixaFaturamento: 'Sub Faixa',
  porte: 'Porte',
  faturamentoPresumido: 'Faturamento Presumido',
  indicadores: 'Indicadores',
  erro: 'Erro',
  dashboard: 'Dashboard',
  conglomerados: 'Conglomerados',
  permissoes: 'Permissões',
  permissaoPai: 'Permissão Pai',
  identificador: 'Identificador',
  tipoConsulta: 'Tipo Consulta',
  permissao: 'Permissão',
  agruparConsulta: 'Agrupar Consulta',
  qsaAtualizado: 'QSA Atualizado',
  dataSaida: 'Dt. Saída',
  motivos: 'Motivos Score',
  dataSolicitacao: 'Dt. Solicitação',
  partes: 'Partes',
  movimentacoes: 'Movimentações',
  polo: 'Polo',
  advogados: 'Advogados',
  urlRedirect: 'URL Redirect',
  limiteCredito: 'Limite Crédito',
  percentualCapacidadePagamento: 'Percentual Capacidade Pagamento',
  capacidadePagamento: 'Capacidade Pagamento',
  maisNegocio: 'Mais Negócio',
  operacao: 'Operação',
  recomendacao: 'Recomendação',
  risco: 'Risco',
  motivoScore: 'Motivo Score',
  registro:  'Registro',
  dtOcorrencia: 'Dt. Ocorrência',
  dtInclusao: 'Dt. Inclusão',
  registros: 'Registros',
  dt_nascimento: 'Dt. Nascimento',
  dt_ocorrencia: 'Dt. Ocorrência',
  cep: 'CEP',
  notificacao_email: 'Notificação E-mail',
  notificacao_sms: 'Notificação SMS',
  ddd: 'DDD',
  motivoCancelamento: 'Motivo Cancelamento',
  cancelarRegistro: 'Cancelar Registro',
  grauAtividadePJ: 'Grau Atividade PJ',
  participante: 'Participante',
  documentoParticipante: 'Doc. Participante',
  documentoEmpresa: 'Doc. Empresa',
  comportamentoFinanceiro: 'Relacionamento de Negócios - Quantidade de instituições por tempo de relacionamento',
  linhaCredito: 'Linhas de Crédito - Contratos ativos',
  endividamento: 'Endividamento - Compromissos assumidos considerando vencimento final dos contratos',
  pontualidadePagamento: 'Pontualidade de pagamento - Operações Liquidadas nos últimos 12 meses',
  historicoPagamento: 'Histórico Pagamentos - Pontualidade nos últimos 6 meses (em Reais)',
  codigoCliente: 'Código Cliente',
  diaVencimentoFatura: 'Dia Vencimento Fatura',
  dataContratacao: 'Data Contratação',
  dataCadastro: 'Data Cadastro',
  vcm: 'VCM',
  usual: 'Usual',
  arrojado: 'Arrojado',
  conservador: 'Conservador',
  perfilRisco: 'Perfil de Risco',
  analises: 'Análise Setorial (considera empresas do mesmo setor de atividade e porte)',
  nire: 'Nire',
  colaboradores: 'Colaboradores',
  filiais: 'Filiais',
  filiaisRegiao: 'Filiais/Região',
  restricao: 'Restrição',
  relatorioSinteticoDeConsultas: 'Relatório Sintético de Consultas',
  ordenacao: 'Ordenação',
  restricoes: 'Restrições',
  gastoEstimado: 'Gasto Estimado',
  relatorioApuracaoBilhete: 'Relatório Apuração Bilhete',
  whatsappDoSuporte: 'WhatsApp do Suporte',
  loginQuod: 'Login Quod',
  senhaQuod: 'Senha Quod',
  loginSPC: 'Login SPC',
  senhaSPC: 'Senha SPC',
  loginBVS: 'Login BVS',
  senhaBVS: 'Senha BVS',
  loginSerasa: 'Login Serasa',
  senhaSerasa: 'Senha Serasa',
  loginInfoSimples: 'Login Info Simples',
  senhaInfoSimples: 'Senha Info Simples',
  loginProtesto: 'Login Protesto',
  senhaProtesto: 'Senha Protesto',
  tokenScorePositivo: 'Token Score Positivo',
  observacao: 'Observação',
  logoEmpresa: 'Logo da Empresa',
  logoRevendaQuod: 'Logo Revenda Quod',
  parametrosAplicacao: 'Parâmetros da Aplicação',
  restricoesMercado: 'Restrições de Mercado',
  editar: 'Editar',
  qt_inclusao: 'QT. Inclusão',
  qt_exclusao: 'QT. Exclusão',
  trabalhoPrincipal: 'Trabalho Princiapal',
  nivelConfianca: 'Nível Confiança',
  valorParticipacao: 'Valor Participação',
  arquivoRegistro: 'Arquivo Registro',
  historicoVencido: 'Histórico Compromissos Vencidos',
  dataComunicado: 'DT. Comunicado',
  tipoComunicado: 'TP. Comunicado',
  consumidor: 'Consumidor',
  informante: 'Informante',
  refins: 'Refins',
  pefins: 'Pefins',
  dataFundacao: 'Data Fundação',
  quadroSocietario: 'Quadro Societário',
  percentual: 'Percentual',
  idade: 'Idade',
  atividadePrincipal: 'Atividade Principal',
  nomeBanco: 'Nome Banco',
  ccf: 'CCF',
  planos: 'Planos',
  servico: 'Serviço',
  servicos: 'Serviços',
  tipoBilhete: 'Tipo Bilhete',
  valorConsumo: 'Vl. Consumo',
  valorComplementar: 'Vl. Complementar',
  dataReferencia: 'Dt. Referência',
  franquia: 'Franquia',
  plano: 'Plano',
  fatura: 'Fatura',
  faturas: 'Faturas',
  faturamento: 'Faturamento',
  faturamentos: 'Faturamentos',
  dataInicio: 'Dt. Início',
  dataFim: 'Dt. Fim',
  site: 'Site',
  franquias: 'Franquias',
  parametroAplicacao: 'Parâmetro Aplicação',
  bilhetarAgrupador: 'Bilhetar Agrupador',
  sequencia: 'Sequência',
  arquivosRegistro: 'Arquivos Registro',
  nomeComercial: 'Nome Comercial',
  filtro: 'Filtro',
  ip: 'IP',
  protestosSP: 'Protestos estado São Paulo',
  acoesQuod: 'Ações, Falências e Recuperações Judiciais',
  relatorioConsulta: 'Relatório Consulta',
  filtroErro: 'Filtro Erro',
  filtroCache: 'Filtro Cache',
  negativacao: 'Negativação',
  valorMaximo: 'Valor Máximo',
  limitarValorMaximo: 'Limitar Valor Máximo',
  codigoCredor: 'Código Credor',
  nomeDevedor: 'Nome do devedor',
  documentoDevedor: 'Documento do devedor',
  cpfcnpj: 'CPF ou CNPJ',
  senhaAtual: 'Senha Atual',
  scoreQuodVersion: 'Score Quod Versão',
  consumo: 'Consumo',
  informativo: 'Informativo',
  forncedorConsulta: 'Fornecedor Consulta',
  tempoCacheConsulta: 'Tempo Cache Consulta (em minutos)',
  gastoEstimadoPJ: 'Gasto Estimado PJ',
  inadimplenciaPJ: 'Inadimplência PJ',
  dividaAtiva: 'Dívida Ativa',
  notificacao: 'Notificação',
  titulo: 'Título',
  notificacoes: 'Notificações',
  conteudo: 'Conteúdo',
  pendencia: 'Pendência',
  documentoPrincipal: 'Documento Devedor Principal',
  nomePrincipal: 'Nome Devedor Principal',
  consultaAutomotiva: 'Consulta Automotiva',
  consultaCadastralNome: 'Consulta Cadastral por Nome',
  placa: 'Placa',
  chassi: 'Chassi',
  motor: 'Motor',
  renavam: 'Renavam',
  tipoVeiculo: 'Tipo Veículo',
  autenticacaoDoisFatores: 'Autenticação de Dois Fatores',
  escanearQrCode: 'Escanear QR Code',
  validarCodigo: 'Validar Código',
  prosseguir: 'Prosseguir',
  voltar: 'Voltar',
  validar: 'Validar',
  cancelar: 'Cancelar',
  sucesso: 'Sucesso',
  duploFatorInstrucaoQr:
    'Abra seu aplicativo autenticador (Google Authenticator, Microsoft Authenticator, Authy, etc.) e escaneie o QR Code abaixo para adicionar sua conta.',
  duploFatorChaveManual: 'Não consegue escanear? Insira esta chave manualmente:',
  duploFatorInstrucaoCodigo:
    'Digite o código de 6 dígitos gerado pelo seu aplicativo autenticador para concluir a configuração.',
  duploFatorConfiguradoSucesso: 'Autenticação de dois fatores configurada com sucesso!',
  duploFatorQrIndisponivel: 'Não foi possível carregar o QR Code. Tente novamente.',
  duploFatorJaConfiguradoTitulo: 'Dois Fatores já configurado',
  duploFatorJaConfiguradoMensagem:
    'A autenticação de dois fatores já está ativa na sua conta. Não é necessário configurá-la novamente.',
  voltarParaInicio: 'Voltar para o Início',
    chaveAcesso: 'Chave de Acesso',
  chaveAcessoInstrucao:
    'Cadastre uma chave de acesso (passkey) para entrar sem digitar senha, usando biometria, PIN ou chave de segurança do seu dispositivo.',
  adicionarChaveAcesso: 'Adicionar chave de acesso',
  nenhumaChaveAcessoCadastrada: 'Nenhuma chave de acesso cadastrada.',
  nomeDispositivo: 'Nome do dispositivo',
  nomeDispositivoPlaceholder: 'Ex: Notebook do trabalho',
  chaveAcessoCadastradaEm: 'Cadastrada em',
  chaveAcessoUltimoUso: 'Último uso',
  chaveAcessoAdicionadaSucesso: 'Chave de acesso cadastrada com sucesso!',
  chaveAcessoRemovidaSucesso: 'Chave de acesso removida com sucesso!',
  confirmarRemoverChaveAcesso: 'Deseja realmente remover esta chave de acesso?',
  chaveAcessoNaoSuportada: 'Seu navegador não tem suporte a chaves de acesso (passkeys).',
  entrarComChaveAcesso: 'Entrar com chave de acesso',
  remover: 'Remover',

}

i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  resources: {
    'pt-BR': {
      translation: {
        ...ptBrMessages
      }
    }
  }
})
